export default __webpack_public_path__ + "static/media/PortfolioTemplate.c4b4fd27.png";